<template>
    <div  :style="'min-height:'+$minHeight+';'">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <section class="buy_in_bulk_section1">
            <div class="container">
                <div class="gadget-into-cash-container">
                    <div class="gadget-into-cash-content align-items-center shadow">
                        <div class=" align-self-center mb-3 mb-md-0">
                            <div class="gadget-into-cash-logo">
                                <img :src="cmsImagePath + data.cmsData.top_image" width="100%" >
                            </div>
                        </div>
                        <div class="w-100 align-self-center mb-3 mb-md-0">
                            <div class="gadget-into-cash-question">
                                <h3>
                                    {{ data.cmsData.top_title }}
                                </h3>
                            </div>
                        </div>
                        <div class="w-75 align-self-center text-center text-md-right mb-3 mb-md-0">
                            <router-link to="/signup" class="gadget_btn">Sign Up</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="buy_in_bulk_section2">
            <div class="container text-center">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6 col-lg-4 pl-lg-4 pr-lg-4 mb_5rem" v-for="(data, index) in data.cardData" :key="index">
                        <div class="why-gadget-salvation-content">
                            <div class="why-gadget-salvation-item-img">
                                <img :src="imagePath + data.image" alt="" class="buy_in_bulk_section2_img">
                            </div>
                            <div class="why-gadget-salvation-text">
                                <h3 class="why-gadget-subtitle"> {{ data.title }} </h3>
                                <p class="why-gadget-description" v-html="data.detail"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="buy_in_bulk_section3">
            <div class="container">
                <div class="section_header text-center">
                    <h2> {{ data.cmsData.form_title }} </h2>
                </div>
                <div class="buy-in-bulk">
                    <div class="buy-in-bulk-content">
                        <div class="fields-wrapper">
                            <form @submit.prevent="storeFormData">
                                <fieldset class="bg-white">
                                    <legend class="shadow">fill-up the form</legend>
                                    <div class="form-group">
                                        <label for="first_name">First Name</label>
                                        <input class="form-control input_focus" type="text" id="first_name" v-model="firstName" name="first_name" placeholder="Please enter your first name." value="">
                                    </div>
                                    <div class="form-group">
                                        <label class="" for="last_name">Last Name</label>
                                        <input class="form-control input_focus" type="text" id="last_name" v-model="lastName" name="last_name" placeholder="Please enter your last name." value="">
                                    </div>
                                    <div class="form-group">
                                        <label class="is-required" for="email">Email</label>
                                        <input class="form-control input_focus" type="email" id="email" v-model="email" name="email" placeholder="Please enter your email." value="">
                                    </div>
                                    <div class="form-group">
                                        <label class="" for="phone">Phone</label>
                                        <input class="form-control input_focus" type="text" id="phone" v-model="phone" name="phone" placeholder="Please enter your phone number." value="">
                                    </div>
                                    <div class="form-group">
                                        <label class="" for="comments">Comments</label>
                                        <textarea rows="4" cols="50" name="comments" v-model="comments" class="form-control input_focus" placeholder="Please enter comments here..." ></textarea>
                                    </div>
                                    <!-- <div class="captcha_3E5Ul g-recaptcha mb-3">
                                        <div style="max-width: 304px; width: 100%; height: 78px;">
                                            <div>
                                                <iframe title="reCAPTCHA" src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6Lfa9H0UAAAAAMAGt_pKuycKsKYFnIouFWeqInvd&amp;co=aHR0cHM6Ly9jZG4uZm9ybXMtY29udGVudC5zZy1mb3JtLmNvbTo0NDM.&amp;hl=en&amp;v=kcXVPRWG7fMILHmzon0--fD3&amp;size=normal&amp;cb=qgjt43xbl3ab" width="304" height="78" role="presentation" name="a-j9j2y3mihrd6" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"></iframe>
                                            </div>
                                            <textarea id="g-recaptcha-response" name="g-recaptcha-response" class="g-recaptcha-response" style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea>
                                        </div>
                                        <iframe style="display: none;"></iframe>
                                    </div> -->
                                    <div class="submit-container_3HEHv">
                                        <input class="input_X2qHP" type="submit" id="submit" required="" value="Submit" style="background-color: rgb(0, 0, 0); color: rgb(255, 255, 255); border-color: rgb(0, 0, 0); border-width: 0px; border-radius: 4px; padding: 12px 18px;">
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "BulkBuy",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            comments: null,
            data: [],
            imagePath: this.$api + "upload/buy_bulk/",
            cmsImagePath: this.$api + "upload/buy_bulk_cms/"
        }
    },
    created() {
        document.title = "Geek Buy Back - Buy In Bulk";
        this.getData();
    },
    mounted(){
        var pageHeight=window.innerHeight-390;
        this.$minHeight=pageHeight+"px";
    },
    methods: {
        getData: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + this.$config.bulk.getBuyInBulkURL
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    console.log(response.data.data);
                    this.data = response.data.data;
                }

                this.isLoading = false;

                
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        storeFormData: function() {
            this.isLoading = true
            if(!this.firstName || !this.lastName || !this.email || !this.phone || !this.comments) {
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter required fields!"
                });
            }
            else {
                this.$axios.post(this.$api + this.$config.bulk.storeBuyInBulkURL, {
                    first_name: this.firstName,
                    last_name: this.lastName,
                    email: this.email,
                    phone: this.phone,
                    comments: this.comments
                }).then((response) => {
                    console.log(response);
                    if(response.data.status == "success") {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 2000)
                        this.$swal.fire({
                            icon: "success",
                            text: "Thank you, Your request sent successfully. Our concern will communicate shortly."
                        });

                        this.firstName="";
                        this.lastName="";
                        this.email="";
                        this.phone="";
                        this.comments="";
                    }
                    else {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 2000)
                        this.$swal.fire({
                            icon: "error",
                            text: "Failed! please try again."
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 2000)
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                })
            }
        }
    }
}
</script>
<style scoped>
    .gadget-into-cash-logo img {
        width: 100px;
    }

    .why-gadget-salvation-item-img {
        margin-top: -51px;
    }
</style>